import BaseNotification from '../BaseNotification'

export default class FullPaymentRequired extends BaseNotification {
  get processedMessage(): string {
    return super.processedMessage.replace('{payNowLink}', this.fullPaymentPath)
  }

  get fullPaymentPath(): string {
    return this.notification.paymentAllowed
      ? `
          Please
          <router-link
            :to="{
              name: 'makePayment',
              query: { bookingId: '${this.notification.enquiryId}' },
            }"
          >
            Pay now
          </router-link>.
        `
      : ''
  }

  get iconClass(): string {
    return 'sc-icon-money-box'
  }
}
